<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    灵芝站<br>
站点介绍<br>
灵芝站位于前进一路与创业二路交汇处，延创业二路呈南北向布设。毗邻环境优美的灵芝公园，周边汇聚宝安中学、新安中学、文汇中学多所人文教育学府及中洲•πmall、海雅缤纷城大型购物中心。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:57	5号线	3分钟	5分25秒<br>
黄贝岭	06:23	23:24	5号线	3分钟	5分25秒<br>
左炮台东	06:31	23:27	12号线	4分钟	8分钟<br>
海上田园东	06:20	23:44	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	23:56	5号线	4分钟	6分钟<br>
黄贝岭	06:31	23:24	5号线	4分钟	6分钟<br>
左炮台东	06:35	23:27	12号线	8分钟	8分钟<br>
海上田园东	06:22	23:44	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	00:56	5号线	4分钟	6分钟<br>
黄贝岭	06:31	00:24	5号线	4分钟	6分钟<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
创业二路南侧(西)、前进一路西侧、冠城世家、新安中学、新安湖小学、宝安汽车站、恒明珠国际金融中心<br><br>
B2出入口:<br>
灵芝公园、创业二路南侧（东）、前进一路东侧、深圳市宝安区司法局、深圳市宝安公证处、深信泰丰大厦、冠利达大厦、翡翠华庭<br><br>
C1出入口:<br>
创业二路北侧（东）、宝安中医院、中洲购物中心<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 灵芝地铁站1<br>
M182、M378、B832、高峰专线56号<br><br>
A1出入口:<br>
公交站名： 灵芝地铁站<br>
M371、M395、M518、高峰专线102、高快巴士33、606、610、E23、M197、M249、M250、M378、高峰专线56号<br><br>
A1出入口:<br>
公交站名： 宝安税务局<br>
M349、395、615、M249、M425、高峰专线138、B832<br><br>
B2出入口:<br>
公交站名： 灵芝公园北<br>
610、629、M182、M245、M313、M378、M393、M395、高峰专线56号、B831<br><br>
B2出入口:<br>
公交站名： 宝安税务局<br>
615、M249、M349、M425、高峰专线138、395<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shierhaoxian",
          title: "12号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


